import React from 'react';

import './FormError.less';

/**
 *
 * @param {{
 *  id?: string;
 *  show?: boolean;
 *  text?: string;
 *  children?: React.ReactNode|React.ReactNode[];
 * }} props
 * @returns {null|React.ReactElement}
 */
export const FormError = props => {
  const { id, text = '', show = false, children } = props;
  return (show ? <div className="lsn-form-error-message" role={'alert'} {...{ id }}>
    {text}
    {children}
  </div> : null);
};

export default FormError;
